export const characters = {
  A: 3,
  B: 1,
  C: 2,
  D: 2,
  E: 3,
  F: 1,
  G: 2,
  H: 2,
  I: 3,
  J: 1,
  K: 1,
  L: 2,
  M: 2,
  N: 2,
  O: 3,
  P: 2,
  Q: 1,
  R: 3,
  S: 2,
  T: 2,
  U: 2,
  V: 1,
  W: 1,
  X: 1,
  Y: 1,
  Z: 1,
  "1": 1,
  "2": 1,
  "3": 1,
  "4": 1,
  "5": 1,
  "6": 1,
  "7": 1,
  "8": 1,
  "9": 1,
  "0": 1,
  "@": 1,
  "#": 1,
  "&": 1,
};

export const replacementCharacters = {
  A: ["U"],
  C: ["U"],
  E: ["3"],
  I: ["1"],
  M: ["W"],
  O: ["0"],
  S: ["5"],
  U: ["C"],
  W: ["M"],
  "1": ["I"],
  "5": ["S"],
  "3": ["E"],
  "6": ["9"],
  "9": ["6"],
  "0": ["O"],
};